module.exports = __webpack_public_path__ + "img/health-mission.22824101.svg";